import { render, staticRenderFns } from "./table-percentile.component.html?vue&type=template&id=4e5619cd&scoped=true&external"
import script from "./table-percentile.component.ts?vue&type=script&lang=ts&external"
export * from "./table-percentile.component.ts?vue&type=script&lang=ts&external"
import style0 from "./table-percentile.component.scss?vue&type=style&index=0&id=4e5619cd&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5619cd",
  null
  
)

export default component.exports